import { Product } from '../enums/booking';

export const getUniformProduct = (product: string) => {
    const lowerCaseProduct = product.toLowerCase();

    if (/bus/.test(lowerCaseProduct)) return Product.BUS;
    if (/flight/.test(lowerCaseProduct)) return Product.FLIGHT;
    if (/hotel/.test(lowerCaseProduct)) return Product.HOTEL;
    if (/train/.test(lowerCaseProduct)) return Product.TRAIN;

    return '';
};
